import { render, staticRenderFns } from "./fg-footer.vue?vue&type=template&id=879a505a"
import script from "./fg-footer.vue?vue&type=script&lang=js"
export * from "./fg-footer.vue?vue&type=script&lang=js"
import style0 from "./fg-footer.vue?vue&type=style&index=0&id=879a505a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports